$(function(){
  var url = window.location;

  // Will also work for relative and absolute hrefs
  $('ul.navigation > li > a').filter(function() {
      return this.href == url;
  }).parent().addClass('current');
  
    $('ul.navigation li li a').filter(function() {
      return this.href == url;
  }).closest( "ul" ).addClass('sub-menu');
});

$("ul.navigation > li > ul > li a").each(function() {   
    if (this.href == window.location.href) {
        $(this).addClass("active-sidebar-link");
    }
});